export const sendPostMessageToChatIA = (type = "user_info", payload = "") => {
  const chatIframe = document.getElementById(
    "intelliframe"
  ) as HTMLIFrameElement | null;
  const chatOrigin =
    document.getElementById("eva-widget")?.getAttribute("data-origin") || "*";

  if (chatIframe) {
    chatIframe?.contentWindow?.postMessage(
      { type: type, payload: payload },
      chatOrigin
    );
  }
};
